import React from 'react';
import PropTypes from 'prop-types';
import { pluralise } from '@lib/utils';
import Money from '@components/application/money';

const ColourVehicleCard = ({ vehicle, placeholderImg }) => {
  return (
    <div className="ch-bb--1 ch-bc--grey-3 ch-pa--1 sm:ch-pa--2">
      <div className="ch-display--flex ch-justify-content--center ch-flex-flow--row-wrap ch-mt--1 ch-mh--1">
        <a
          className="ch-width--4"
          data-gtm-track="interaction"
          data-gtm-track-action="Online showroom"
          data-gtm-track-label="Clicked pre-reg card - Vehicle image"
          href={vehicle.product_page_url}
        >
          <img
            alt={`${vehicle.make} ${vehicle.model} details`}
            className="ch-rounded--sm ch-img--responsive"
            height="263"
            src={vehicle.image_url ? vehicle.image_url : placeholderImg}
            width="350"
          />
        </a>
        <div className="ch-lh--heading sm:ch-mt--1 ch-pl--2 ch-width--8 ch-text--ellipsis ">
          <a
            className="ch-color--ac-black ch-text--bold ch-fs--4 ch-text-decoration--none"
            data-gtm-track="interaction"
            data-gtm-track-action="Online showroom"
            data-gtm-track-label="Clicked pre-reg card - Vehicle title"
            href={vehicle.product_page_url}
          >
            {vehicle.year}
            {vehicle.plate ? ` (${vehicle.plate}) ` : ' '}
            {vehicle.make} {vehicle.model}
          </a>
          <div className="ch-text--ellipsis">{vehicle.variant}</div>
          <div className="ch-mt--1 sm:ch-mt--2 ch-color--grey-5">
            Mileage: {vehicle.mileage} {pluralise(vehicle.mileage, 'mile')}
          </div>
          <div className="ch-mt--1 sm:ch-mt--2 ch-ba--1 ch-bc--grey-2 ch-bg--grey-2 ch-rounded--sm branchname">
            <span className="ch-text--ellipsis">{vehicle.branch_name}</span>
          </div>
        </div>
        <div className="ch-display--flex ch-width--12 ch-mv--2">
          <div className="ac-pricing ch-pv--1 ch-lh--base ch-flex-flow--column-wrap">
            <div className="ch-fs--1 md:ch-fs--2">
              {vehicle.pricing?.cashPricePrefix}
            </div>
            <div className="ch-fs--4">
              <Money amount={vehicle.pricing?.cashPrice} />
            </div>
          </div>
          {vehicle.pricing?.monthlyPayment && (
            <>
              <div className="ac-text-divider__vertical ch-relative"></div>
              <div className="ac-pricing sl:ch-ml--2 sm:ch-ml--0 md:ch-ml--2 ch-pv--1 ch-lh--base ch-flex-flow--row--nowrap ch-align-items--center">
                <div className="ch-flex-flow--column-wrap ch-lh--base ch-ml--2 sl:ch-ml--0">
                  <div className="ch-fs--1 md:ch-fs--2">Deposit</div>
                  <div className="ch-fs--4">
                    <Money amount={vehicle.pricing?.deposit} />
                  </div>
                </div>
                <div className="ch-ph--2">+</div>
                <div className="ch-flex-flow--column-wrap ch-lh--base">
                  <div className="ch-fs--1 md:ch-fs--2">Per month</div>
                  <div className="ch-fs--4">
                    <Money amount={vehicle.pricing?.monthlyPayment} />
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      <div className="ch-display--flex ch-justify-content--center">
        <a
          className="ch-btn ch-btn--sm ch-btn--success ch-ma--1 ch-width--6 js-off--hide"
          data-gtm-track="click_cta"
          data-gtm-track-action="Online showroom"
          data-gtm-track-label="Reserve now"
          href={vehicle.reserve_now_url}
          rel="nofollow"
        >
          Reserve now
        </a>
        <noscript className="ch-ma--1 ch-width--6">
          <a
            className="ch-btn ch-btn--sm ch-btn--success ch-width--12"
            data-gtm-track="click_cta"
            data-gtm-track-action="Online showroom"
            data-gtm-track-label="Enquire now"
            href={`/contact-us/vehicle-enquiry/${vehicle.stock_reference}`}
            rel="nofollow"
          >
            Enquire now
          </a>
        </noscript>
        <a
          className="ch-btn ch-btn--sm ch-ma--1 ch-width--6"
          data-gtm-track="interaction"
          data-gtm-track-action="Online showroom"
          data-gtm-track-label="Clicked pre-reg card - view details"
          href={vehicle.product_page_url}
        >
          View details
        </a>
      </div>
    </div>
  );
};

export default ColourVehicleCard;

ColourVehicleCard.propTypes = {
  placeholderImg: PropTypes.string,
  vehicle: PropTypes.object,
};
